module.exports = __webpack_public_path__ + "img/custom_bg1.8c733179.png";